const TeethLayoutConfig = {
  quadrant1: {
    child: [55, 54, 53, 52, 51],
    adult: [18, 17, 16, 15, 14, 13, 12, 11]
  },
  quadrant2: {
    child: [61, 62, 63, 64, 65],
    adult: [21, 22, 23, 24, 25, 26, 27, 28]
  },
  quadrant3: {
    child: [85, 84, 83, 82, 81],
    adult: [38, 37, 36, 35, 34, 33, 32, 31]
  },
  quadrant4: {
    child: [71, 72, 73, 74, 75],
    adult: [41, 42, 43, 44, 45, 46, 47, 48]
  }
};

export default TeethLayoutConfig;
